import { ENV_STAGE } from 'src/constants/env-constants';
// Import directly from the module (not the src/enums barrel) to avoid pulling in
// OfferTierBadgeCopy, which depends on OFFER_TIER from the theme and breaks tests
// that partially-mock @amzn/sss-website-theme.
import { STAGE } from 'src/enums/Stage';

/**
 * Resolves the current deployment stage from the build-time injected `prod`
 * token (exposed as {@link ENV_STAGE}) rather than inspecting the browser URL.
 *
 * If the token was not substituted (e.g. local standalone dev where the raw
 * `prod` placeholder is served), we fall back to {@link STAGE.BETA}.
 */
export const getCurrentStage = (): STAGE => {
  const stage = ENV_STAGE.toLowerCase();
  switch (stage) {
    case STAGE.GAMMA:
      return STAGE.GAMMA;
    case STAGE.PROD:
      return STAGE.PROD;
    case STAGE.BETA:
      return STAGE.BETA;
    default:
      // Unsubstituted token (`{{stage}}`) or unknown value — treat as non-prod.
      return STAGE.BETA;
  }
};

/**
 * Ordering (placing an EAC order) must be blocked in Gamma so that Gamma testing
 * cannot create real orders against the shared production backend.
 */
export const isOrderingBlockedForStage = (): boolean => getCurrentStage() === STAGE.GAMMA;
